import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .ant-table-sticky-holder {
    top: 80px !important;
  }
  > .ant-table-wrapper {
    > .ant-spin-nested-loading {
      > .ant-spin-container {
        > .ant-table {
          > .ant-table-container {
            table {
              border-collapse: separate;
              border-spacing: 6px;

              .ant-table-thead {
                > tr {
                  > th {
                    background: none;
                    border-bottom: 0;

                    &:before {
                      display: none;
                    }
                  }
                }
              }

              .ant-table-tbody {
                > tr {
                  > td {
                    background: #f4faff;

                    &.bold {
                      font-weight: bold;
                    }

                    &.is-status {
                      padding: 0;

                      .status-block {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        &.is-active {
                          background-color: #e3ffef;
                        }

                        &.is-inactive {
                          background-color: #fbd3d3;
                        }
                      }
                    }
                  }
                }
              }

              .ant-checkbox-inner::after {
                border-spacing: 0px;
              }
            }
          }
        }
      }
    }
  }
`

export default Styled
